//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      user: {
      },
      date: '',
      isLoading: false,
      page: 0,
      isEnd: false,
      list: []
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.user = vm.$store.state.oice.user || vm.user
      vm.date = vm.$dateFormat(new Date(), 'YYYY-M-D')
      vm.loadListData(true)
    })
  },
  methods: {
    new () {
      this.$router.push({name: 'DailyEdit', params: {id: 0}})
    },
    loadMore () {
      if (!this.isLoading && !this.isEnd) {
        this.page++
        this.loadListData()
      }
    },
    loadListData (empty) {
      if (empty) {
        this.isEnd = false
        this.page = 1
        this.list = []
      }
      this.isLoading = true
      this.$post('/api/daily/index', {
        page: this.page,
        date: this.date
      }, (res) => {
        this.isLoading = false
        if (res.success) {
          let newData = res.data
          if (!newData || newData.length < 10) {
            this.isEnd = true
          }
          for (let item in newData) {
            this.list.push(newData[item])
          }
        }
      })
    }
  },
  watch: {
    scrollBottom (isBottom) {
      if (isBottom && this.$route.name === 'Daily') {
        this.loadMore()
      }
    }
  },
  computed: {
    ...mapState({
      scroolTop: state => state.oice.scroolTop,
      scrollBottom: state => state.oice.scrollBottom
    }),
    loadingTip () {
      if (this.isLoading) {
        return '正在加载'
      } else if (this.isEnd) {
        return this.list.length ? '没有更多了' : '暂无数据'
      } else {
        return '加载更多'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/index/views/Daily/Index.vue